/* eslint-disable no-magic-numbers */
import { IntlShape } from 'react-intl';

import { PeriodType } from '../../../../core/constants';

// only use yyyy-MM-dd part
const getCurrentDate = () => new Date().toISOString().slice(0, 10);

/**
 * Returns file name for export sheet route
 * @param entityName Organisation or consolidation name
 * @param intl useIntl for translating
 * @param forecastName Current forecast name
 * @param forecastKind Current forecast type
 * @param periodType Current period type
 * @returns File name for exporting
 */
export const getExportFilename = (
  entityName: string,
  intl: IntlShape,
  forecastName?: string,
  forecastKind?: 'live' | 'budget' | 'scenario',
  periodType?: PeriodType
): string => {
  let translatedPeriodType = '';
  switch (periodType) {
    case 'MONTHLY':
      translatedPeriodType = intl.formatMessage({ id: 'export.monthly', defaultMessage: 'monthly' });
      break;
    case 'WEEKLY_MONDAY':
      translatedPeriodType = intl.formatMessage({ id: 'export.weekly_monday', defaultMessage: 'weekly_monday' });
      break;
    case 'WEEKLY_SUNDAY':
      translatedPeriodType = intl.formatMessage({ id: 'export.weekly_sunday', defaultMessage: 'weekly_sunday' });
      break;
    default:
      translatedPeriodType = '';
      break;
  }

  if (forecastKind === 'live') {
    return intl.formatMessage(
      {
        id: 'export.filename.live',
        defaultMessage: 'Predict {periodType} export: {entityName} [{date}]'
      },
      {
        periodType: translatedPeriodType,
        entityName,
        date: getCurrentDate()
      }
    );
  } else {
    return intl.formatMessage(
      {
        id: 'export.filename.not_live',
        defaultMessage: 'Predict {periodType} export: {entityName} - {forecastName} [{date}]'
      },
      {
        periodType: translatedPeriodType,
        entityName,
        forecastName,
        date: getCurrentDate()
      }
    );
  }
};

/**
 * Returns file name for import sheet route
 * @param organisationName Organisation name
 * @param intl useIntl for translating
 * @param forecastName Current forecast name
 * @param forecastKind Current forecast type
 * @returns File name for importing sheet
 */
export const getImportFilename = (
  organisationName: string,
  intl: IntlShape,
  forecastName?: string,
  forecastKind?: 'live' | 'budget' | 'scenario'
): string => {
  if (forecastKind === 'live') {
    return intl.formatMessage(
      {
        id: 'import.filename.live',
        defaultMessage: 'Predict import: {organisationName} [{date}]'
      },
      {
        organisationName,
        date: getCurrentDate()
      }
    );
  } else {
    return intl.formatMessage(
      {
        id: 'import.filename.not_live',
        defaultMessage: 'Predict import: {organisationName} - {forecastName} [{date}]'
      },
      {
        organisationName,
        forecastName,
        date: getCurrentDate()
      }
    );
  }
};
